import { NavLink, Outlet } from "react-router"
import portplay_logo from '../../../assets/images/logo-portplay-horizontal.svg';
import icon_close from '../../../assets/images/icon-close.svg';
import icon_hamburger from '../../../assets/images/icon-hamburger-01.svg';
import icon_discord from '../../../assets/images/icon-discord.png';
import icon_mail from '../../../assets/images/icon-mail.png';

import { Footer } from "./Footer";


import styled from 'styled-components'
import { BoxImage } from "./widgets/BoxImage";
import { useState } from "react";

export const Wrapper = styled.article`

  .title-container {
    padding-left: 0.5rem;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 100;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    background: var(--accent2);
    border-bottom: 1px solid var(--white);
  }

  .menu-container {
    display: flex;
    align-items: center;
  }

  .outlet-container {
    display: flex;
    align-items: center;
    padding-top: 70px;
  }

  .menu-container {
    position: absolute;
    top: 70px;
    left: 0px;
    width: 100%;
    flex-direction: column;
    background: var(--pagebackground);
    z-index: 10;
  }

  @media (min-width: 992px) {
    .title-container {
      background: var(--accent2);
    }

    .menu-container {
      display: flex !important;
      position: relative;
      top: 0px;
      flex-direction: row;
      background: transparent;
      justify-content: space-between;
      width: 80%;
      padding-left: 3rem;
      padding-right: 3rem;
    }
  }

  .toggle-button-container {
    cursor: pointer;
    padding-top: 0.5rem;
    padding-right: 0.5rem;
  }
  .soc-button-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    background: var(--accent2);
    width: 100%;
    padding-top: 0.5rem;
    padding-left: 0.25rem;
    padding-right: 0.25rem;
    border-top: 1px solid var(--white);
  }

  @media (min-width: 992px) {
    .toggle-button-container {
      display: none;
    }
    .soc-button-container {
      display: none;
    }

  }

`
export const MainLayout = () => {

  const [open, setOpen] = useState<boolean>(false);

  return (
    <Wrapper>
      <div>
        <div className="title-container">
          <NavLink to='/' className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link' } style={{cursor: 'pointer'}}>
            <div style={{cursor: 'pointer'}}><BoxImage url={portplay_logo} w='200px' alt='port play'/></div>
          </NavLink>
          <div className="toggle-button-container" onClick={() => open ? setOpen(false) : setOpen(true)}>
            <BoxImage url={open ? icon_close : icon_hamburger} w='50px' alt={open ? 'close menu' : 'open menu'}/>
          </div>
          <div className="menu-container" style={open ? { display: 'flex'} : {display: 'none'}}>
            <div className="center-text">
              <NavLink to='whatson' className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link' }>
                <div className='nav'>What's On</div>
              </NavLink>
            </div>
            {/* <div className="center-text">
              <NavLink to='schedule' className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link' }>
                <div className='nav'>Schedule</div>
              </NavLink>
            </div> */}
            <div className="center-text">
              <NavLink to='makersmarket' className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link' }>
                <div className='nav'>Makers Market</div>
              </NavLink>
            </div>
            <div className="center-text">
              <NavLink to='faqs' className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link' }>
                <div className='nav'>Faq</div>
              </NavLink>
            </div>
            <div className="center-text">
              <NavLink to='conduct' className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link' }>
                <div className='nav'>Conduct</div>
              </NavLink>
            </div>
            <div className="center-text"><span className='nav'>tickets soon</span></div>
            <div className="soc-button-container">
              <div style={{marginRight: '1.5rem'}}><a href="https://discord.gg/M9Wq7wzdC4"><img src={icon_discord} alt='discord' style={{width:'40px', height: '40px', paddingLeft: '50px'}}/></a></div>
              <div><a href='mailto:arcanacon.orgs@gmail.com'><img src={icon_mail} alt='email arc' style={{width:'40px', height: '40px', paddingRight: '50px'}}/></a></div>
            </div>
          </div>
        </div>
      </div>
      <div className='outlet-container'>
        <Outlet />
      </div>
      <div>
        <Footer />
      </div>

    </Wrapper>
  )
}